import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { filter, switchMap, take, catchError, throwError, EMPTY } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const protectedUrls = new InjectionToken<string[]>('protectedUrls');

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const msalService = inject(MsalService);
  const protectedApis = inject(protectedUrls);
  const authService = inject(AuthenticationService);
  const isProtectedRoute = protectedApis.some(api => req.url.includes(api));
  // If it's not a protected route, just let it through
  if (!isProtectedRoute) {
    return next(req);
  }

  const apiScope = AUTH_CONFIG.SCOPE;

  return authService.authReady$.pipe(
    filter(ready => ready),
    take(1),
    switchMap(() => {
      const account =
        authService.getActiveAccount() ||
        msalService.instance.getActiveAccount() ||
        msalService.instance.getAllAccounts()[0];

      if (!account) {
        msalService.loginRedirect({
          scopes: ['offline_access', apiScope]
        });

        return EMPTY;
      }

      return msalService.acquireTokenSilent({
        account,
        scopes: [apiScope]
      }).pipe(
        catchError(error => {
          console.error('Silent token acquisition failed', error);

          if (error instanceof InteractionRequiredAuthError) {
            msalService.loginRedirect({
              scopes: ['offline_access', apiScope]
            });
          }

          return throwError(() => error);
        }),
        switchMap(result => {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${result.accessToken}`
            }
          });

          return next(authReq);
        })
      );
    })
  );
};
